import * as v from 'valibot';
import { IdSchema, UserIdSchema, ResourceTypeSchema, SubjectTypeSchema, ActionSchema } from './common.js';
export const PermissionSchema = v.object({
    id: IdSchema,
    resourceType: ResourceTypeSchema,
    resourceId: IdSchema,
    subjectType: SubjectTypeSchema,
    subjectId: UserIdSchema,
    action: ActionSchema,
    createdAt: v.pipe(v.string(), v.isoTimestamp())
});
export const CreateUserPermissionSchema = v.object({
    resourceType: ResourceTypeSchema,
    resourceId: IdSchema,
    subjectType: v.literal('user'),
    subjectId: UserIdSchema,
    action: ActionSchema
});
export const CreateGroupPermissionSchema = v.object({
    resourceType: ResourceTypeSchema,
    resourceId: IdSchema,
    subjectType: v.literal('group'),
    subjectId: IdSchema,
    action: ActionSchema
});
export const CreatePermissionSchema = v.variant('subjectType', [
    CreateUserPermissionSchema,
    CreateGroupPermissionSchema
]);
//# sourceMappingURL=permissions.js.map